export default __webpack_public_path__ + "static/media/sailboat.d6bec554.png";